import React, { ReactNode } from 'react';
import styled, { css } from 'styled-components';

import { CheckIfChildHasPropertyHref } from '../../../utils/md-utils/md-utils';

import check from '../../../images/check.svg';
import checkYellow from '../../../images/check-yellow.svg';
import arrow from '../../../images/small-arrow-right.svg';

type ListItemProps = React.ComponentPropsWithoutRef<'li'> & {
  children?: React.ReactNode;
  inverted?: boolean;
};

const ListItem = ({ children, inverted }: ListItemProps) => {
  const isListItemWithLink = CheckIfChildHasPropertyHref(children);

  return (
    <StyledListItem isAnchorLink={isListItemWithLink} inverted={inverted}>
      {children}
    </StyledListItem>
  );
};

export default ListItem;

const StyledListItem = styled.li<{
  isAnchorLink?: boolean;
  inverted?: boolean;
}>`
  list-style: none;
  position: relative;

  &:before {
    background: url(${({ isAnchorLink, inverted }) => {
        if (isAnchorLink) return arrow;
        return inverted ? checkYellow : check;
      }})
      no-repeat;
    content: '';
    height: 1rem;
    left: -21px;
    position: absolute;
    top: 6px;
    transition: 0.1s ease-in-out;
    width: 1rem;
  }

  ${({ isAnchorLink }) =>
    isAnchorLink
      ? css`
          &:hover {
            &:before {
              left: -14px;
            }
          }
        `
      : undefined}
`;
